import React from 'react';
import Header from '../Components/Header/Header';
import ContactUs from '../Components/ContactUs/ContactUs';
import Footer from '../Components/Footer/Footer';



const HomePage = () => {
  return (
    <div>
      <Header />
      <ContactUs/>
      <Footer />
      
    </div>
  );
};

export default HomePage;
